import { render, staticRenderFns } from "./aliintl.vue?vue&type=template&id=5152c78d&scoped=true"
import script from "./aliintl.vue?vue&type=script&lang=js"
export * from "./aliintl.vue?vue&type=script&lang=js"
import style0 from "./aliintl.vue?vue&type=style&index=0&id=5152c78d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5152c78d",
  null
  
)

export default component.exports